import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ProjectState {
  id: string;
  customerId: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrentProjectStateService {
  private currentProject = new BehaviorSubject<ProjectState | null>(null);
  private userId = new BehaviorSubject<string | null>(null);

  setCurrentProject(project: ProjectState): void {
    this.currentProject.next(project);
  }

  getCurrentProject(): Observable<ProjectState | null> {
    return this.currentProject.asObservable();
  }

  getCurrentProjectValue(): ProjectState | null {
    return this.currentProject.getValue();
  }

  setUserId(userId: string): void {
    this.userId.next(userId);
  }

  getUserId(): Observable<string | null> {
    return this.userId.asObservable();
  }

  getUserIdValue(): string | null {
    return this.userId.getValue();
  }

  clear(): void {
    this.currentProject.next(null);
    this.userId.next(null);
  }
}